import React from "react";
import { IconButton, Tooltip, CircularProgress } from "@mui/material";

import { useKakaoDeckCardShare } from "@/shared/hooks/kakao/useKakaoDeckCardShare";
import { DeckCardKakaoShareInput } from "@/modules/kakao";
import KakaoIcon from "./KakaoIcon";

export type KakaoDeckCardShareButtonProps = {
  shareInput: DeckCardKakaoShareInput;
  onShared?: () => void;
  disabled?: boolean;
  size?: "small" | "medium";
  darkMode?: boolean;
  tooltip?: string;
};

const KakaoDeckCardShareButton: React.FC<KakaoDeckCardShareButtonProps> = ({
  shareInput,
  onShared,
  disabled = false,
  size = "small",
  darkMode = false,
  tooltip = "Share on KakaoTalk",
}) => {
  const { shareDeckCard, isSharing, isConfigured } = useKakaoDeckCardShare();

  if (!isConfigured) {
    return null;
  }

  const handleShare = async () => {
    const ok = await shareDeckCard(shareInput);
    if (ok) {
      onShared?.();
    }
  };

  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          onClick={() => void handleShare()}
          disabled={disabled || isSharing}
          size={size}
          aria-label={tooltip}
          sx={{
            color: darkMode ? "#FEE500" : "#3b2f00",
            bgcolor: darkMode ? "rgba(254, 229, 0, 0.12)" : "#FEE500",
            "&:hover": {
              bgcolor: darkMode ? "rgba(254, 229, 0, 0.22)" : "#f5dc00",
            },
            "&.Mui-disabled": {
              bgcolor: darkMode
                ? "rgba(254, 229, 0, 0.08)"
                : "rgba(254, 229, 0, 0.45)",
            },
          }}
        >
          {isSharing ? (
            <CircularProgress size={18} sx={{ color: "inherit" }} />
          ) : (
            <KakaoIcon size={18} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default KakaoDeckCardShareButton;
